import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    uploadZoneWrapper: {
        display: "flex",
        width: "100%",
        border: `2px dashed ${theme.palette.primary.dark}`,
        backgroundColor: theme.palette.backgrounds.main,
        borderRadius: 4,
        padding: 12,
        justifyContent: "center",
        flexDirection: "column",
        cursor: "pointer",
    },
    icon: {
        color: theme.palette.primary.dark,
        fontSize: 20,
    },
    mainLine: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        fontFamily: "Open Sans",
        color: theme.palette.primary.dark,
        fontSize: 14,
        gap: theme.spacing(1),
    },
    hintLine: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        fontFamily: "Open Sans",
        color: theme.palette.primary.dark,
        fontSize: 12,
    },
}));
